import { usePageConfigProviderContext } from "src/features/PageConfigProvider";
import { useTranslation } from "src/hooks";
import {
  TableColumnKey,
  TableRow,
} from "src/views/WalletManagement/WalletBalanceMonitor/types/Table";

function InfoFieldSection({ rowData }: { rowData: TableRow }) {
  const { translatePrefix } = usePageConfigProviderContext();
  const { t } = useTranslation(translatePrefix);
  const array = [
    {
      label: t(TableColumnKey.ChainName),
      data: rowData[TableColumnKey.ChainName],
    },
    {
      label: t(TableColumnKey.Currency),
      data: rowData[TableColumnKey.Currency],
    },
    {
      label: t(TableColumnKey.WalletAddress),
      data: rowData[TableColumnKey.WalletAddress],
    },
  ];

  return (
    <div
      style={{
        display: "grid",
        gridTemplateColumns: "1fr 0.8fr",
        rowGap: "28px",
      }}
    >
      {array.map((item, index) => (
        <div
          key={index}
          style={{
            display: "grid",
            gridTemplateColumns: "0.3fr 1fr",
            gap: "8px",
            fontSize: "12px",
          }}
        >
          <div>{item.label}</div>
          <div>{item.data}</div>
        </div>
      ))}
    </div>
  );
}

export default InfoFieldSection;
